module.exports = __webpack_public_path__ + "img/logo-large-lsh.5dc75c36.png";